import { Pipe, PipeTransform, inject } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { SettingsService } from '../services/settings.service';

@Pipe({
  name: 'centsToCurrency',
  standalone: true
})
export class CentsToCurrencyPipe implements PipeTransform {
  private currencyPipe = new CurrencyPipe('en-US');
  private settingsService = inject(SettingsService);

  transform(value: string | number | null | undefined, currencyCode?: string, display: string = 'symbol-narrow', digitsInfo: string = '1.2-2'): string | null {
    if (value == null || value === '') return null;

    const numericValue = typeof value === 'string' ? parseFloat(value) : value;

    if (isNaN(numericValue)) return null;

    const code = currencyCode ?? this.settingsService.getActiveCurrency();

    return this.currencyPipe.transform(numericValue / 100, code, display, digitsInfo);
  }
}
